import { render } from "./InputAmount.vue?vue&type=template&id=37ad7e22&scoped=true"
import script from "./InputAmount.vue?vue&type=script&lang=js"
export * from "./InputAmount.vue?vue&type=script&lang=js"

import "./InputAmount.vue?vue&type=style&index=0&id=37ad7e22&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37ad7e22"]])

export default __exports__